var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"content"},[_c('h4',{staticClass:"title is-4"},[_vm._v(_vm._s(_vm.$t('nav.ourServices')))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('ourServices'))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }